<!--
 * @Author: your name
 * @Date: 2020-10-21 11:33:00
 * @LastEditTime: 2021-03-09 10:59:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\AdminMember\AdminApplication.vue
-->
<template>
  <div id='adminApplication' ref="adminApplication">
    <!-- <el-tabs class="admin_content" v-model="activeName" @tab-click="handleTabClick" v-if="tabIndex==0"> -->
    <el-tabs class="admin_content" v-model="activeName" @tab-click="handleTabClick" v-if="tabIndex==0">
      <el-row class="taskTitle">
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="taskLeft">
          <el-row v-if="activeName=='1'||activeName=='2'">
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="rightBorder" :class="{active:activeIndex==0?true:false}" @click.native="allTask">全部</el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="rightBorder" :class="{active:activeIndex==1?true:false}" @click.native="aboutToTimeOut">即将超时</el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" :class="{active:activeIndex==2?true:false}" @click.native="timeOut">已经超时</el-col>
          </el-row>
          <div v-if="activeName=='3'" class="complete"><img src="@/assets/img/已完成.png" alt=""> 已完成</div>
        </el-col>
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="taskRight">
          <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="colOne">
            <span style="display:none;">1</span>
            <template v-if="activeName=='1'">
              <span>任务状态: </span>
              <el-select v-model="taskParams.taskStatus" clearable placeholder="请选择任务状态" @change="conditionChange">
                <el-option label="未被领取" :value="1">
                </el-option>
                <el-option label="已被领取" :value="2">
                </el-option>
              </el-select>
            </template>
          </el-col>
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-select v-model="taskParams.applyType" clearable placeholder="请选择申请类型" @change="conditionChange">
              <el-option v-for="item in applyTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="colThree">
            <el-date-picker v-model="startChangeTime" type="daterange" range-separator="至" start-placeholder="发起开始日期" end-placeholder="发起结束日期" @change="dateChange">
            </el-date-picker>
          </el-col>
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="colFour">
            <el-input placeholder="请输入公司名" clearable v-model="taskParams.companyName" @change="conditionChange">
              <img slot="prefix" src="@/assets/img/search.png" alt="">
            </el-input>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" class="colFive">
            排序<img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg">
          </el-col>
        </el-col>
      </el-row>
      <el-tab-pane name="1" label="全部任务" v-if="tabIndex==0">
        <el-row v-if="activeIndex==0">
          <template v-if="taskList.length<=0">
            <el-row class="noData">暂无审核数据</el-row>
          </template>
          <template v-else>
            <el-row class="taskContent" v-for="(item,index) in taskList" :key="index">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol">
                <el-col v-if="item.applyStatus==1" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#0066cc;">
                  <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
                </el-col>
                <el-col v-if="item.applyStatus==2" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#ffae00;">
                  <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
                </el-col>
                <el-col v-if="item.applyStatus==3" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#dd3924;">
                  <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
                </el-col>
                <!-- <el-col v-if="item.applyStatus==4" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#3ee1b4;">
                  <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
                </el-col> -->
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="textCommon">
                  <p>{{item.applyName}}</p>
                  <!-- <p v-if="item.applyType==1">调查表审核</p>
                  <p v-if="item.applyType==2">产品发布</p>
                  <p v-if="item.applyType==3">申请入会</p>
                  <p v-if="item.applyType==4">资质、补贴及荣誉审核</p>
                  <p v-if="item.applyType==5">企业联系人审核</p>
                  <p v-if="item.applyType==6">缴费凭证审核</p>
                  <p v-if="item.applyType==7">文件审核</p> -->
                  <p class="startTime" v-if="item.applyStatus==1">
                    {{item.updateTime | timeChange}} 更新
                  </p>
                  <p class="timeOut" v-if="item.applyStatus==2">
                    剩余时间:{{item.soonTimeOut}}
                    <el-popover popper-class="timeOutDay" placement="top-start" title="" width="200" trigger="hover" :content="`剩余${item.soonTimeOutDay}未处理`">
                      <img slot="reference" src="@/assets/img/问号.png" alt="">
                    </el-popover>
                  </p>
                  <p class="timeOut" v-if="item.applyStatus==3">
                    已超时:{{item.lastTime}}
                    <el-popover popper-class="timeOutDay" placement="top-start" title="" width="200" trigger="hover" :content="`已经${item.timeOutDay}未处理`">
                      <img slot="reference" src="@/assets/img/问号.png" alt="">
                    </el-popover>
                  </p>
                </el-col>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColTwo">
                <p class="commonName">发起公司名: {{item.companyName}}</p>
                <p class="startTime">发起时间: {{item.createTime | timeChange}}</p>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColThree">
                <!-- <template v-if="item.applyStatus==4">
                  <p class="startTime">
                    处理人: {{item.handlerName}}
                  </p>
                </template> -->
                <template>
                  <!-- 1未领取任务 -->
                  <template v-if="item.taskStatus==1&&item.userName==null&&item.handlerName==null">
                    <p class="start">上一个节点:无</p>
                    <p class="startTime">
                      处理人: 无
                    </p>
                  </template>
                  <template v-if="item.taskStatus==1&&item.userName!=null&&item.handlerName==null">
                    <el-link class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                    <p class="startTime">
                      处理人: 无
                    </p>
                  </template>
                  <template v-if="item.taskStatus==1&&item.userName==null&&item.handlerName!=null">
                    <p class="start">上一个节点:无</p>
                    <p class="startTime">
                      处理人: {{item.handlerName}}
                    </p>
                  </template>
                  <template v-if="item.taskStatus==1&&item.userName!=null&&item.handlerName!=null">
                    <el-link class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                    <p class="startTime">
                      处理人: {{item.handlerName}}
                    </p>
                  </template>
                  <!-- 2已领取任务 -->
                  <template v-if="item.taskStatus==2&&item.userName==null&&item.handlerName==null">
                    <p class="start">上一个节点:无</p>
                    <p class="startTime">
                      处理人: 无
                    </p>
                  </template>
                  <template v-if="item.taskStatus==2&&item.userName!=null&&item.handlerName==null">
                    <el-link class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                    <p class="startTime">
                      处理人: 无
                    </p>
                  </template>
                  <template v-if="item.taskStatus==2&&item.userName==null&&item.handlerName!=null">
                    <p class="start">上一个节点:无</p>
                    <p class="startTime">
                      处理人: {{item.handlerName}}
                    </p>
                  </template>
                  <template v-if="item.taskStatus==2&&item.userName!=null&&item.handlerName!=null">
                    <el-link class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                    <p class="startTime">
                      处理人: {{item.handlerName}}
                    </p>
                  </template>
                </template>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColFour">
                <!-- <template v-if="item.applyStatus==4">
                  <p style="text-align: center;">已驳回</p>
                  <el-popover placement="bottom" width="100" title="原因" trigger="click" popper-class="application" :content="reasonData.comment==''||reasonData.comment==null?'无':reasonData.comment">
                    <el-link slot="reference" class="reason" @click="reason(item.id)">查看原因</el-link>
                  </el-popover>
                </template> -->
                <!-- <template v-if="item.applyStatus==5">
                  <p class="link" style="text-align: center;">通过</p>
                </template> -->
                <template v-if="item.applyStatus==1||item.applyStatus==2||item.applyStatus==3">
                  <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="detail">
                    <template v-if="item.taskStatus==1">
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                      <el-link class="last" @click="receiveTask(item)">接收任务</el-link>
                    </template>
                    <template v-if="item.taskStatus==2">
                      <template v-if="item.recipientPerson==userId">
                        <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                        <p style="cursor:pointer;" @click="refuseTask(item.id)">任务退回</p>
                      </template>
                      <template v-else>
                        <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                      </template>
                    </template>
                  </el-col>
                  <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" style="padding-right:20px;" v-if="item.applyStatus==2||item.applyStatus==3">
                    <img src="@/assets/img/急.png" alt="">
                  </el-col>
                </template>
              </el-col>
            </el-row>
          </template>
        </el-row>
        <el-row v-if="activeIndex==1">
          <template v-if="taskList.length<=0">
            <el-row class="noData">暂无即将超时数据</el-row>
          </template>
          <template v-else>
            <el-row class="taskContent" v-for="(item,index) in taskList" :key="index">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol">
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#ffae00;">
                  <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="textCommon">
                  <p>{{item.applyName}}</p>
                  <!-- <p v-if="item.applyType==1">调查表审核</p>
                  <p v-if="item.applyType==2">产品发布</p>
                  <p v-if="item.applyType==3">申请入会</p>
                  <p v-if="item.applyType==4">资质、补贴及荣誉审核</p>
                  <p v-if="item.applyType==5">企业联系人审核</p>
                  <p v-if="item.applyType==6">缴费凭证审核</p>
                  <p v-if="item.applyType==7">文件审核</p> -->
                  <p class="timeOut">
                    剩余时间:{{item.soonTimeOut}}
                    <el-popover popper-class="timeOutDay" placement="top-start" title="" width="200" trigger="hover" :content="`剩余${item.soonTimeOutDay}未处理`">
                      <img slot="reference" src="@/assets/img/问号.png" alt="">
                    </el-popover>
                  </p>
                </el-col>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColTwo">
                <p class="commonName">发起公司名: {{item.companyName}}</p>
                <p class="startTime">发起时间: {{item.createTime | timeChange}}</p>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColThree">
                <el-link v-if="item.taskStatus==1&&item.userName!==null" class="link" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                <el-link v-if="item.taskStatus==2&&item.userName!=null&&item.handlerName!==null" class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                <p v-if="item.taskStatus==1&&item.userName==null" class="start">上一个节点:无</p>
                <p v-if="item.taskStatus==2&&item.userName==null" class="startTime">上一个节点:无</p>
                <p v-if="item.handlerName!==null" class="startTime">
                  处理人: {{item.handlerName}}
                </p>
                <p v-if="item.handlerName==null" class="startTime">
                  处理人: 无
                </p>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColFour">

                <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="detail">
                  <template v-if="item.taskStatus==1&&item.handlerName==null">
                    <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                    <el-link class="last" @click="receiveTask(item)">接收任务</el-link>
                  </template>
                  <template v-if="item.taskStatus==2">
                    <template v-if="item.recipientPerson==userId">
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                      <p style="cursor:pointer;" @click="refuseTask(item.id)">任务退回</p>
                    </template>
                    <template v-else>
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                    </template>
                  </template>
                </el-col>
                <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" style="padding-right:20px;">
                  <img src="@/assets/img/急.png" alt="">
                </el-col>
              </el-col>
            </el-row>
          </template>
        </el-row>
        <el-row v-if="activeIndex==2">
          <template v-if="taskList.length<=0">
            <el-row class="noData">暂无已超时数据</el-row>
          </template>
          <template v-else>
            <el-row class="taskContent" v-for="(item,index) in taskList" :key="index">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol">
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#dd3924;">
                  <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="textCommon">
                  <p>{{item.applyName}}</p>
                  <!-- <p v-if="item.applyType==1">调查表审核</p>
                  <p v-if="item.applyType==2">产品发布</p>
                  <p v-if="item.applyType==3">申请入会</p>
                  <p v-if="item.applyType==4">资质、补贴及荣誉审核</p>
                  <p v-if="item.applyType==5">企业联系人审核</p>
                  <p v-if="item.applyType==6">缴费凭证审核</p>
                  <p v-if="item.applyType==7">文件审核</p> -->
                  <p class="timeOut">
                    已超时:{{item.lastTime}}
                    <el-popover popper-class="timeOutDay" placement="top-start" title="" width="200" trigger="hover" :content="`已经${item.timeOutDay}未处理`">
                      <img slot="reference" src="@/assets/img/问号.png" alt="">
                    </el-popover>
                  </p>
                </el-col>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColTwo">
                <p class="commonName">发起公司名: {{item.companyName}}</p>
                <p class="startTime">发起时间: {{item.createTime | timeChange}}</p>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColThree">
                <el-link v-if="item.taskStatus==1&&item.userName!==null" class="link" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                <el-link v-if="item.taskStatus==2&&item.userName!=null&&item.handlerName!==null" class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
                <p v-if="item.taskStatus==1&&item.userName==null" class="start">上一个节点:无</p>
                <p v-if="item.taskStatus==2&&item.userName==null" class="start">上一个节点:无</p>
                <p v-if="item.handlerName!==null" class="startTime">
                  处理人: {{item.handlerName}}
                </p>
                <p v-if="item.handlerName==null" class="startTime">
                  处理人: 无
                </p>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColFour">
                <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="detail">
                  <template v-if="item.taskStatus==1&&item.handlerName==null">
                    <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                    <el-link class="last" @click="receiveTask(item)">接收任务</el-link>
                  </template>
                  <template v-if="item.taskStatus==2">
                    <template v-if="item.recipientPerson==userId">
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                      <p style="cursor:pointer;" @click="refuseTask(item.id)">任务退回</p>
                    </template>
                    <template v-else>
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                    </template>
                  </template>
                </el-col>
                <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" style="padding-right:20px;">
                  <img src="@/assets/img/急.png" alt="">
                </el-col>
              </el-col>
            </el-row>
          </template>
        </el-row>
      </el-tab-pane>
      <el-tab-pane name="2" label="需要我审批的">
        <span slot="label">
          <el-badge class="remainTips" :value="pendingTotal" type="warning">
            需要我审批的
          </el-badge>
        </span>
        <template v-if="taskList.length<=0">
          <el-row class="noData">暂无需要我审批数据</el-row>
        </template>
        <template v-else>
          <el-row class="taskContent" v-for="(item,index) in taskList" :key="index">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol">
              <el-col v-if="item.applyStatus==1" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#0066cc;">
                <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
              </el-col>
              <el-col v-if="item.applyStatus==2" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#ffae00;">
                <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
              </el-col>
              <el-col v-if="item.applyStatus==3" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#dd3924;">
                <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
              </el-col>
              <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="textCommon">
                <p>{{item.applyName}}</p>
                <!-- <p v-if="item.applyType==1">调查表审核</p>
                <p v-if="item.applyType==2">产品发布</p>
                <p v-if="item.applyType==3">申请入会</p>
                <p v-if="item.applyType==4">资质、补贴及荣誉审核</p>
                <p v-if="item.applyType==5">企业联系人审核</p>
                <p v-if="item.applyType==6">缴费凭证审核</p>
                <p v-if="item.applyType==7">文件审核</p> -->
                <p class="startTime" v-if="item.applyStatus==1">
                  {{item.updateTime | timeChange}} 更新
                </p>
                <p class="timeOut" v-if="item.applyStatus==2">
                  剩余时间:{{item.soonTimeOut}}
                  <el-popover popper-class="timeOutDay" placement="top-start" title="" width="200" trigger="hover" :content="`剩余${item.soonTimeOutDay}未处理`">
                    <img slot="reference" src="@/assets/img/问号.png" alt="">
                  </el-popover>
                </p>
                <p class="timeOut" v-if="item.applyStatus==3">
                  已超时:{{item.lastTime}}
                  <el-popover popper-class="timeOutDay" placement="top-start" title="" width="200" trigger="hover" :content="`已经${item.timeOutDay}未处理`">
                    <img slot="reference" src="@/assets/img/问号.png" alt="">
                  </el-popover>
                </p>
              </el-col>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColTwo">
              <p class="commonName">发起公司名: {{item.companyName}}</p>
              <p class="startTime">发起时间: {{item.createTime | timeChange}}</p>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColThree">
              <el-link v-if="item.taskStatus==1&&item.userName!==null" class="link" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
              <el-link v-if="item.taskStatus==2&&item.userName!=null&&item.handlerName!==null" class="linkStyle" @click="lastNode(item.id)">上一个节点:{{item.userName}}</el-link>
              <p v-if="item.taskStatus==1&&item.userName==null" class="start">上一个节点:无</p>
              <p v-if="item.taskStatus==2&&item.userName==null" class="start">上一个节点:无</p>
              <p v-if="item.handlerName!==null" class="startTime">
                处理人: {{item.handlerName}}
              </p>
              <p v-if="item.handlerName==null" class="startTime">
                处理人: 无
              </p>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColFour">
              <template v-if="item.applyStatus==1||item.applyStatus==2||item.applyStatus==3">
                <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="detail">
                  <template v-if="item.taskStatus==1&&item.handlerName==null">
                    <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                    <el-link class="last" @click="receiveTask(item)">接收任务</el-link>
                  </template>
                  <template v-if="item.taskStatus==2">
                    <template v-if="item.recipientPerson==userId">
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                      <p style="cursor:pointer;" @click="refuseTask(item.id)">任务退回</p>
                    </template>
                    <template v-else>
                      <p style="cursor:pointer;" @click="gToQuesNare(item)">详情</p>
                    </template>
                  </template>
                </el-col>
                <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" style="padding-right:20px;" v-if="item.applyStatus==2||item.applyStatus==3">
                  <img src="@/assets/img/急.png" alt="">
                </el-col>
              </template>
            </el-col>
          </el-row>
        </template>
      </el-tab-pane>
      <el-tab-pane name="3" label="已完成流程">
        <template v-if="taskList.length<=0">
          <el-row class="noData">暂无已完成数据</el-row>
        </template>
        <template v-else>
          <el-row class="taskContent" v-for="(item,index) in taskList" :key="index">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol">
              <el-col v-if="item.applyStatus==4||item.applyStatus==5" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="squareCommon" style="background-color:#3ee1b4;">
                <img class="squareImg" src="@/assets/img/申请审批.png" alt="">
              </el-col>
              <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="textCommon">
                <p>{{item.applyName}}</p>
                <!-- <p v-if="item.applyType==1">调查表审核</p>
                <p v-if="item.applyType==2">产品发布</p>
                <p v-if="item.applyType==3">申请入会</p>
                <p v-if="item.applyType==4">资质、补贴及荣誉审核</p>
                <p v-if="item.applyType==5">企业联系人审核</p>
                <p v-if="item.applyType==6">缴费凭证审核</p>
                <p v-if="item.applyType==7">文件审核</p> -->
                <p class="startTime" v-if="item.applyStatus==4||item.applyStatus==5">
                  {{item.updateTime | timeChange}} 更新
                </p>
              </el-col>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColTwo">
              <p class="commonName">发起公司名: {{item.companyName}}</p>
              <p class="startTime">发起时间: {{item.createTime | timeChange}}</p>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColThree">
              <template v-if="item.applyStatus==4||item.applyStatus==5">
                <p class="startTime">
                  处理人: {{item.handlerName}}
                </p>
              </template>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="commonCol commonColFour">
              <template v-if="item.applyStatus==4">
                <p style="text-align: center;cursor: pointer;" @click="gToQuesNare(item)">已驳回</p>
                <el-popover placement="bottom" width="100" title="原因" trigger="click" popper-class="application" :content="reasonData.comment==''||reasonData.comment==null?'无':reasonData.comment">
                  <el-link slot="reference" class="reason" @click="reason(item.id)">查看原因</el-link>
                </el-popover>
              </template>
              <template v-if="item.applyStatus==5">
                <p class="link pass" @click="gToQuesNare(item)">通过</p>
              </template>
            </el-col>
          </el-row>
        </template>
      </el-tab-pane>
      <!-- 审批 -->
      <!-- <el-dialog :title="applyFlag==1?'审批操作':'审批拒绝'" :visible.sync="applyVisible" width="25%" custom-class="addInfoVisible" @close="closeApplyDialog">
        <span slot="footer" class="dialog-footer" v-if="applyFlag==1">
          <span class="button add" type="primary" @click="isSuccess(5)">通 过</span>
          <span class="button" @click="applyFlag=2">拒 绝</span>
        </span>
        <template v-else-if="applyFlag==2">
          <el-row>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">拒绝原因:</el-col>
            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
              <el-input type="textarea" v-model="reasonPrams.comment" placeholder="请填写拒绝原因"></el-input>
            </el-col>

          </el-row>
          <span slot="footer" class="dialog-footer">
            <span class="button add" type="primary" @click="isSuccess(4)">确 定</span>
          </span>
        </template>
      </el-dialog>-->
      <!-- 上一节点审批历史记录 -->
      <el-dialog title="审批历史" :visible.sync="historyVisible" width="26%" custom-class="historyVisible" @close="clearHistory">
        <el-scrollbar wrap-class="scrollbar" view-class="view-box" view-style="height:100%;" :native="false" v-if="historyData.length>0">
          <el-row class="process" v-for="(item,index) in historyData" :key="index">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="processOne">
              <div class="round"></div>
              <div class="line"></div>
            </el-col>
            <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21" class="processTwo">
              <el-row>
                <!-- <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="processTwo"> -->
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <span>{{item.userName}}</span>

                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">

                  <span>{{item.createTime}}</span>
                </el-col>
                <!-- <div>
                  </div> -->
                <!-- <div> -->

                <!-- </el-col>
                      <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="processThree"> -->

                <!-- </div> -->
                <!-- </el-col> -->
              </el-row>
              <el-row class="hisReason">
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <span>退回原因</span>

                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">

                  <span>{{item.returnReason}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-scrollbar>
        <div v-else style="text-align: center;height: 50px;">无审批历史</div>
      </el-dialog>
      <el-pagination class="one" @current-change="taskCurrent" :current-page.sync="taskParams.pageNumber" :page-size="taskParams.pageSize" layout="total, prev, pager, next" :total="totalPage">
      </el-pagination>
      <!-- 任务退回 -->
      <BackDialog />
    </el-tabs>
    <template v-else-if="tabIndex==1">
      <Questionnaire :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==4">
      <HonorInfo :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==5">
      <Contact :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==6">
      <Payment :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==7">
      <FileManagement :quesNaireData="quesNaireData" />
    </template>
  </div>
</template>
<script>
import adminApplicationJs from '@/assets/js/AdminMember/adminApplication'
export default {
  ...adminApplicationJs
}

</script>
<style lang='less' scoped>
#adminApplication {
  padding: 0 25px;
  /deep/.admin_content {
    .el-tabs__nav{
      padding-top: 10px;
    }
    .taskTitle {
      width: 100%;
      height: 34px;
      line-height: 34px;
      margin: 15px 0 30px;
      .el-col {
        height: 100%;
        img{
          margin-top: 10px;
        }
      }
      .taskLeft {
        .el-row {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
          border: solid 1px #d9d9d9;
          .el-col {
            text-align: center;
            cursor: pointer;
          }
          .rightBorder {
            border-right: solid 1px #d9d9d9;
          }
        }
        .complete {
          img {
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
      .taskRight {
        .el-input__inner {
          background-color: #f3f6f9;
          height: 32px;
          line-height: 32px;
          .el-range__icon,.el-range-separator{
            line-height: 24px;
          }
        }
        .el-select .el-input .el-select__caret {
          height: 32px;
          line-height: 32px;
        }
        .colOne {
          padding-left: 20px;
          .el-select {
            width: 72%;
          }
        }
        .colThree {
          padding-left: 22px;
          .el-range-editor .el-range-input {
            background: #f3f6f9;
          }
          .el-date-editor--daterange.el-input__inner {
            width: 95%;
          }
        }
        .colFive {
          padding-left: 20px;
        }
      }
    }
    .taskContent {
      width: 100%;
      height: 90px;
      background-color: #ffffff;
      padding: 15px;
      margin-bottom: 20px;
      .commonCol {
        height: 100%;
        border-right: solid 1px #d9d9d9;
        .squareCommon {
          width: 18%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          margin-right: 17px;
          // background-color: #dd3924;
        }
        // .bgcolor {
        //   background-color: #dd3924;
        // }
        .textCommon {
          .timeOut {
            color: #dd3924;
            padding-top: 25px;
            img {
              width: 16px;
              vertical-align: middle;
              padding-left: 20px;
            }
          }
        }
      }
      .commonCol:nth-last-child(1) {
        border-right: none;
      }
      .startTime {
        color: #999;
        padding-top: 25px;
      }
      .start {
        color: #999;
      }
      .link {
        color: #0066cc;
        // padding-top: 25px;
      }
      .pass {
        text-align: center;
        line-height: 60px;
        cursor: pointer;
      }
      // .linkStyle {
      //   color: #0066cc !important;
      // }
      .commonColTwo {
        text-align: center;
        color: #6a707e;
        padding: 0px 10px;
      }
      .commonColThree {
        text-align: center;
      }
      .commonColFour {
        position: relative;
        color: #0066cc;
        .el-col {
          text-align: right;
        }
        .detail {
          text-align: center;
          p:nth-last-child(1),
          .last {
            color: #0066cc;
            padding-top: 25px;
          }
        }
        .reason {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          color: #0066cc;
          padding-top: 25px;
        }
      }
    }
    /deep/.historyVisible {
      .el-dialog__body {
        padding: 20px;
        max-height: 320px;
      }
      .el-dialog__header {
        text-align: left;
      }
      .process {
        width: 100%;
        height: 170px;
        .processOne {
          position: relative;
          .round {
            position: absolute;
            width: 10px;
            height: 10px;
            background-color: #f3f6f9;
            border: solid 1px #0566cc;
            border-radius: 50%;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
          }
          .line {
            position: absolute;
            top: 12px;
            left: 50%;
            transform: translate(-50%, 0);
            width: 2px;
            height: 160px;
            background-color: #e9e9e9;
          }
        }
        .hisReason {
          margin-top: 20px;
        }
        .processTwo {
          margin-left: 40px;
        }
      }
      .scrollbar {
        max-height: 320px;
      }
      .el-scrollbar__thumb {
        background-color: #2879dc;
      }
    }

    /deep/.remainTips {
      .el-badge__content.is-fixed {
        top: 10px;
        right: 2px;
      }
    }
  }
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #666 !important;
  }
}
</style>